import {
  call,
  select,
  put,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { userAccountCreationStep } from '../userAccountCreationStep';
import { userSelector } from '../../../../../../selectors';
import { handleSpecialUsersSignin } from '../../../../signin/sagas/afterSignin';
import Routes from '../../../../../../routes';

export function* companyAdminSignupFlow(flow = 'company_admins', options) {
  yield call(userAccountCreationStep, flow, options);
  const user = yield select(userSelector);
  if(user.profiles.length > 0 && user.profiles[0].type === 'companyAdmin') {
    yield put(push(Routes.companyAdminBase));
  } else {
    yield call(handleSpecialUsersSignin, options, user); // RH/MJG Admins
  }
  return true;
}
